import React, { useState } from "react";
import './App.css';
import { TbHandFinger } from "react-icons/tb";
import { SlPlane } from "react-icons/sl";
import { HiOutlineDesktopComputer } from "react-icons/hi";
import { BiSmile } from "react-icons/bi";

const App = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [options, setOptions] = useState(["Chennai", "Coimbatore", "Agartala"]);

  const handleOptionsChange = (event) => {
    const { value } = event.target;
    setSelectedOption(value);
  };

  const handleButtonClick = () => {
    // Perform any necessary validation or checks here before setting the selected option
    setSelectedOption(options[0]); // Set the first option as selected
  };
  return (
    <>
    <header>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid d-flex justify-content-center">
          <a className="navbar-brand fs-2 fw-bolder" href="#">
            <strong><SlPlane/>AIP @ FINGERTIPS<TbHandFinger /></strong>
          </a>
        </div>
      </nav>
      </header>


     <main className="container">
      <div className="d-flex justify-content-center">
        <input className="" placeholder="Select Aerodrome..." type="text" list="options-list" onChange={handleOptionsChange} />
        <datalist id="options-list">
          {options.map((option, index) => (
            <option key={index} value={option} />
          ))}
        </datalist>
        {/* <button className="btn btn-outline-success mx-2" onClick={handleButtonClick}>Confirm</button> */}
      </div>

      {selectedOption && (
        <div className="container">
          <div className="row">
            <div className="col">
              <table className="table align-items-center justify-content-center">
                <thead>
                  <tr className="table align-items-center justify-content-center fs-4">
                    <th>AERODROME</th>
                    <th>AIP</th>
                  </tr>
                </thead>
                <tbody >
                  <tr className="fs-4">
                    <td >{selectedOption}</td>
                    {(() => {
                      if (selectedOption.toLowerCase().trim() === "coimbatore") {
                        return (
                          <td>
                            <button className="btn btn-outline-success mx-2">
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn fs-4"
                                href="https://aim-india.aai.aero/eaip-v2-04-2023/eAIP/IN-AD%202.1VOCB-en-GB.html"
                              >
                                {selectedOption} AIP
                              </a>
                            </button>
                          </td>
                        );
                      } else if (selectedOption.toLowerCase().trim() === "agartala") {
                        return (
                          <td>
                            <button className="btn btn-outline-success mx-2">
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn"
                                href="https://aim-india.aai.aero/eaip-v2-04-2023/eAIP/IN-AD%202.1VEAT-en-GB.html"
                              >
                                {selectedOption} AIP
                              </a>
                            </button>
                          </td>
                        );
                      } else if (selectedOption.toLowerCase().trim() === "chennai") {
                        return (
                          <td>
                            <button className="btn btn-outline-success mx-2">
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn"
                                href="https://aim-india.aai.aero/eaip-v2-04-2023/eAIP/IN-AD%202.1VOMM-en-GB.html"
                              >
                                {selectedOption} AIP
                              </a>
                            </button>
                          </td>
                        );
                      } else {
                        return <td>No Data Available</td>;
                      }
                    })()}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      </main>

      <footer>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid d-flex justify-content-center">
          <a className="navbar-brand fs-2 fw-bolder" href="#">
            <strong><HiOutlineDesktopComputer/>By Kshitize Dimri<BiSmile/></strong>
            
          </a>
        </div>
      </nav>
      </footer>





      

      
    </>
  );
};

export default App;
